import { ApplicationConfig } from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum ProposalsLocalActionTypes {
  GetConfigSuccess = '[Proposals Local] Get Config Success',
  GetConfigFailure = '[Proposals Local] Get Config Failure',
  GetPartnerConfigsSuccess = '[Proposals Local] Get Partner Configs Success',
  GetPartnerConfigsFailure = '[Proposals Local] Get Partner Configs Failure',
}

export const ProposalsLocalActions = {
  getConfigSuccess: createAction(
    ProposalsLocalActionTypes.GetConfigSuccess,
    props<{ config: ApplicationConfig }>()
  ),

  getConfigFailure: createAction(
    ProposalsLocalActionTypes.GetConfigFailure,
    props<{ error: any }>()
  ),

  getPartnerConfigsSuccess: createAction(
    ProposalsLocalActionTypes.GetPartnerConfigsSuccess,
    props<{ configs: ApplicationConfig[] }>()
  ),

  getPartnerConfigsFailure: createAction(
    ProposalsLocalActionTypes.GetPartnerConfigsFailure,
    props<{ error: any }>()
  ),
};
